
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-06-06-r3f-gltf-animations",
      function () {
        return require("private-next-pages/blogs/2025-06-06-r3f-gltf-animations/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-06-06-r3f-gltf-animations"])
      });
    }
  